export default "__VITE_ASSET__D1MM77UG__"